'use client'
import * as Dialog from 'primitives/dialog'
import * as React from 'react'
import { localStore } from 'utils/storage'

import { JoinClubhouseModal } from '../../join-clubhouse-modal'
import { useClubhousesIsMemberQuery } from '@web/gen/clubhouses'

export const ShowJoinModal = ({ slug }: { slug: string }) => {
  const LOCAL_STORAGE_KEY = `hideJoinModal_${slug}`
  const [isOpen, setIsOpen] = React.useState(false)

  const { data: isMember } = useClubhousesIsMemberQuery(
    { input: { clubhouseSlug: slug } },
    {
      select: data => data?.clubhousesIsClubhouseMember?.isMember,
    },
  )
  React.useEffect(() => {
    const rawValue = localStore.getString(LOCAL_STORAGE_KEY)
    const dismissedAt = Number(rawValue)

    // If parsed value is not a number, remove it from localStorage
    if (rawValue && isNaN(dismissedAt)) {
      localStore.remove(LOCAL_STORAGE_KEY)
    }

    const shouldShowModal =
      !isMember && // only when explicitly not a member
      !isOpen &&
      (!rawValue || isNaN(dismissedAt) || Date.now() - dismissedAt > 86_400_000)

    if (shouldShowModal) {
      const timer = setTimeout(() => {
        setIsOpen(true)
      }, 10_000)

      return () => clearTimeout(timer)
    }
  }, [isMember, isOpen, slug, LOCAL_STORAGE_KEY])

  return (
    <>
      <Dialog.Root
        open={isOpen}
        onOpenChange={open => {
          if (!open) {
            localStore.setString(LOCAL_STORAGE_KEY, Date.now().toString())
            setIsOpen(false)
          }
        }}
        defaultOpen={false}
      >
        <React.Suspense fallback={null}>
          <Dialog.Portal>
            <Dialog.Body
              dismissable={false}
              className="font-poppins xl:overflow-y-auto xl:py-10"
              zIndex={2000}
            >
              <JoinClubhouseModal slug={slug} onClose={() => setIsOpen(false)} />
            </Dialog.Body>
          </Dialog.Portal>
        </React.Suspense>
      </Dialog.Root>
    </>
  )
}
